import { DialogOptions } from '../../../models/modal.model'
import { NotificationOptions } from '../../../models/notification.model'

export type FileNotificationCode = 'UPLOAD_FAILED' | 'DUPLICATED_FILE_NAME'

export type FileModalCode = 'MISSING_FIELDS'

/**
 * Parse file code to a notification
 * @param code - the file notification code
 * @returns the notification options
 */
export function parseFileNotification(
  code?: FileNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'UPLOAD_FAILED':
      return {
        message: 'Upload failed',
        color: 'error',
      }
    case 'DUPLICATED_FILE_NAME':
      return {
        message: 'Duplicated file name',
        color: 'error',
      }
    default:
      return {}
  }
}

/**
 * Parse file code to an modal
 * @param code - the file modal code
 * @param file - the file object
 * @returns the modal settings
 */
export function parseFileModal(code: FileModalCode): DialogOptions {
  switch (code) {
    case 'MISSING_FIELDS': {
      return {
        title: 'Missing fields',
        message:
          'In order to continue managing these files all additional parameters must be filled in',
        buttons: ['Ok'],
      }
    }
    default:
      return {}
  }
}
